import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import Covid19Constants from '../../../common/Covid19Constants';
import Covid19Utils from '../../../common/Covid19Utils';
import Covid19Action from '../../../redux/actions/Covid19Action';
import { ConfigSelector } from '../../../redux/reducers/ConfigReducer';
import { PlansSelector } from '../../../redux/reducers/PlansReducer';
import Covid19Tickbox from './Covid19Tickbox';
import Covid19Confirmation from './Covid19Confirmation';
import './Covid19Confirmation.scss';

const preferredConnectionDateForUfbReady = (isUfbAvailable, isUfbReady, delayedDaysForModemDelivery, isByoModemSelected) => {
  let message = 'In most cases, it will take up to 5 to 7 working days to get you connected with Skinny Fixed-line Broadband. We can’t provide an exact date as the process involves third parties, but we’ll do our best to be in touch as soon as we know when your connection will be switched on. Most connections won’t even need a technician to come around but in some cases, one may need to pay a visit to make sure you’re all set.​';
  if (isByoModemSelected) {
    message = 'Select your preferred connection date below, we will attempt to get you connected on the date requested. We will keep you updated about any changes to this date.';
  } else {
    if (isUfbAvailable) {
      message = 'If you signed up to one of our Fibre plans and this is your first time ordering it at your place, it can take 4 – 6 weeks, but sometimes up to 8 weeks. In the meantime, we’ll be with you during the whole installation process and we can also get you connected to a temporary ADSL connection if it’s available at your address. ​';
    }
    if (isUfbReady) {
      message = delayedDaysForModemDelivery
        ? 'Select your preferred connection date below, we will attempt to get you connected on the date requested. We will keep you updated about any changes to this date.'
        : 'Fibre is already installed at your address so we can get you connected quickly. You won’t need a technician to get you connected and we’ll be in touch as soon as we know when your connection will be switched on.';
      // message = 'Select your preferred connection date below,
      // please note that given the current situation with Covid - 19
      // causing modem delivery delays you can’t choose an earlier date at the the moment.';
    }
  }
  return (
    <div className="container nullify-section-margin-top">
      <h3 className="half-charcoal">Preferred connection date</h3>
      <p>{message}</p>
      {!isUfbReady ? <p>
        Just a heads up - unfortunately we don&apos;t have control over third
        party appointments.
      </p> : null}
    </div>
  );
}

;

const preferredConnectionDateUfbNotreadyBeforeLockDownEndDate = (props, lockDownEndDate, provider, handleChange) =>
  <div className="container nullify-section-margin-top covid-19-preferred-connection-date-section">
    <h3 className="half-charcoal">Preferred connection date</h3>
    <p className="covid-19-confirmation-text">
      Due to the COVID-19 situation, appointments for essential services will be prioritised.
      This means other orders may need to wait slightly longer for a technician appointment.
      If you are an essential business or service, please tick the box below and provide us details of your business.
    </p>
    <Field
      id="is-essential-service"
      name="isEssentialService"
      label={Covid19Constants.signup.isEssentialService.label}
      component={Covid19Tickbox}
      props={{
        ...props,
        handleChange: Covid19Utils.isChorus(provider) ? () => {} : handleChange
      }}
    />
    <Covid19Confirmation />
    <p className="covid-19-confirmation-text" style={{ paddingTop: '20px' }}>
      Important! Please help us keep people safe by not booking any technician visits within the next 14 days
      if there is someone in self-isolation or with Coronavirus symptoms at the connection address.
      If this is the case then the connection date cannot be earlier than 14 days from today.
      Technicians will confirm this onsite and additional precautions will be taken.
    </p>
  </div>
;

const preferredConnectionDateUfbNotreadyAfterLockDownEndDate = () =>
  <div className="container nullify-section-margin-top covid-19-preferred-connection-date-section">
    <h3 className="half-charcoal">Preferred connection date</h3>
    <Covid19Confirmation />
  </div>
;

const preferredConnectionDateUfbNotready = props => Covid19Utils.isLockDownEndDatePast(props.lockDownEndDate)
  ? preferredConnectionDateUfbNotreadyAfterLockDownEndDate()
  : preferredConnectionDateUfbNotreadyBeforeLockDownEndDate(
    props, props.lockDownEndDate, props.provider, props.handleChange);

const PreferredConnectionDate = (props) => {
  const { isUfbReady, isFibre, isCovid19Mode, isUfbAvailable, delayedDaysForModemDelivery, isByoModemSelected } = props;
  return isUfbReady || !isFibre || !isCovid19Mode
    ? preferredConnectionDateForUfbReady(isUfbAvailable, isUfbReady, delayedDaysForModemDelivery, isByoModemSelected)
    : preferredConnectionDateUfbNotready(props);
};

const mapStateToProps = state => ({
  isUfbReady: PlansSelector.getUfbReady(state),
  isFibre: PlansSelector.isSelectedPlanFibre(state),
  lockDownEndDate: ConfigSelector.getLockDownEndDate(state),
  provider: PlansSelector.getProvider(state),
  isCovid19Mode: ConfigSelector.isCovid19Mode(state),
  isUfbAvailable: PlansSelector.getUfbAvailable(state),
  delayedDaysForModemDelivery: ConfigSelector.getDelayedDaysForModemDelivery(state),
  isByoModemSelected: PlansSelector.getIsByoModemSelected(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    handleChange: Covid19Action.updatedNoCovid19Confirmed
  }, dispatch);

PreferredConnectionDate.propTypes = {
  isUfbReady: PropTypes.bool,
  isFibre: PropTypes.bool,
  isCovid19Mode: PropTypes.bool,
  lockDownEndDate: PropTypes.instanceOf(Date),
  provider: PropTypes.string,
  handleChange: PropTypes.func,
  isUfbAvailable: PropTypes.bool,
  delayedDaysForModemDelivery: PropTypes.number,
  isByoModemSelected: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(PreferredConnectionDate);



/** WEBPACK FOOTER **
 ** ./src/components/checkout/PreferredConnectionDate/PreferredConnectionDate.js
 **/